import { render } from "./Tiles.vue?vue&type=template&id=13e697f1&scoped=true"
import script from "./Tiles.vue?vue&type=script&lang=js"
export * from "./Tiles.vue?vue&type=script&lang=js"

import "./Tiles.vue?vue&type=style&index=0&id=13e697f1&scoped=true&lang=css"
import "./Tiles.vue?vue&type=style&index=1&id=13e697f1&lang=css"

import exportComponent from "/Users/sivasankarelango/Sivasankar/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13e697f1"]])

export default __exports__